import { state, setState } from "./state.js";

export function initPreview(root) {
    const image = root.querySelector("#inko-preview-image");

    const empty = root.querySelector("#inko-preview-empty");

    const canvas = root.querySelector("#inko-preview-canvas");

    const zoomIn = root.querySelector("#inko-zoom-in");

    const zoomOut = root.querySelector("#inko-zoom-out");

    const fit = root.querySelector("#inko-fit-button");

    zoomIn.addEventListener("click", () => {
        setZoom(Math.min(state.zoom + 0.1, 3), image);
    });

    zoomOut.addEventListener("click", () => {
        setZoom(Math.max(state.zoom - 0.1, 0.25), image);
    });

    fit.addEventListener("click", () => {
        setZoom(1, image);
    });

    window.addEventListener("inko:design", (event) => {
        const design = event.detail;

        if (!design || !design.preview_path) {
            return;
        }

        image.src = design.preview_path;

        image.hidden = false;

        empty.hidden = true;

        setZoom(1, image);
    });

    window.addEventListener("inko:preview-url", (event) => {
        const url = event.detail;

        if (!url) {
            return;
        }

        image.src = url;

        image.hidden = false;

        empty.hidden = true;
    });

    function setZoom(value, element) {
        state.zoom = value;

        element.style.transform = `scale(${value})`;
    }
}
